import React, { useEffect } from 'react';
import BackgroundImage from '../components/front/BackgroundImage';
import { colorToArray, isNotEmpty, isColorBright, RGB_2_HEX } from '../lib/ep';
import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText';

const CustomHTMLDomain = (props) => {
	const domain = props?.domain?.Accountdomain ?? false;
	if(domain === false) return null;

	const bg_color = (isNotEmpty(domain, 'background_color')) ? domain.background_color : 'rgba(255, 255, 255, 1)';
	const main_image = domain?.full_main_image ?? false;
	const background_image = domain?.full_background_image ?? false;

	const is_bg_color_bright = isColorBright(RGB_2_HEX(bg_color)) ? true : false;

	useEffect(() => {
		document.documentElement.style.setProperty('--background-color', colorToArray(bg_color, true));
		document.documentElement.style.setProperty('--text-color', ((is_bg_color_bright) ? '0, 0, 0, 1' : '255, 255, 255, 1'));
		document.documentElement.style.setProperty('--h1-color', 'var(--text-color)');
		document.documentElement.style.setProperty('--p-color', 'var(--text-color)');
		document.documentElement.style.setProperty('--selection-bg-color', ((is_bg_color_bright) ? '0, 0, 0' : '255, 255, 255'));
		document.documentElement.style.setProperty('--selection-color', ((is_bg_color_bright) ? '255, 255, 255' : '0, 0, 0'));
	}, []);

	const default_text = `<h1>${domain.domain}</h1>`;

	return (
		<>
			<BackgroundImage
				promotion={{}}
				force_bg_image={background_image}
			/>

			{(main_image !== false) && (
				<div class='gui_pos_rel'>
					<img src={main_image} width='100%' alt="" style={{ maxWidth:'500px' }} />
				</div>
			)}

			{(background_image === false && main_image === false) && (
				<div class='gui_pos_rel is_fullscreen' style={{ alignItems:'center', justifyContent:'center', display:'flex' }}>
					<LeveledHTMLText>{default_text}</LeveledHTMLText>
				</div>
			)}
		</>
	)
}

export default CustomHTMLDomain;